var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 77 65",
    style: {
      enableBackground: "new 0 0 77 65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFAA70;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.2,62.6c7.5-11.2,17-10.8,22.1-9.6s3.8-2.3,3.8-2.3c-2.2-8.7,2.3-13.4,6.2-15.6c3.8-2.3,1.3-4.5,1.3-4.5 c-9.4-5-8.7-12.7-7.8-15.6c0.9-2.9-1.3-2.8-1.3-2.8s-9.2,0.6-12.2-0.1c-7.6-1.6-12.2-9.5-12.2-9.5c-1.6-2.8-3.1,0-3.1,0 s-4.2,7.6-12.2,9.3c-3,0.6-12.2,0.3-12.2,0.3s-2.2-0.1-1.3,2.8s1.6,10.6-7.8,15.6c0,0-2.6,2.2,1.3,4.5c3.8,2.3,8.4,7,6.2,15.6 c0,0-1.3,3.4,3.8,2.3c5.1-1.2,14.6-1.6,22.1,9.6C36.8,62.6,38.5,64.9,40.2,62.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.9,38.9v-14h4.5c1.7,0,2.8,0.1,3.3,0.2c0.8,0.2,1.5,0.7,2,1.4c0.5,0.7,0.8,1.6,0.8,2.7 c0,0.9-0.2,1.6-0.5,2.2s-0.7,1-1.2,1.4c-0.5,0.3-1,0.6-1.4,0.7c-0.7,0.1-1.6,0.2-2.9,0.2h-1.8V39h-2.8V38.9z M21.7,27.3v4h1.5 c1.1,0,1.8-0.1,2.2-0.2c0.4-0.1,0.7-0.4,0.9-0.7c0.2-0.3,0.3-0.7,0.3-1.1c0-0.5-0.1-0.9-0.4-1.3c-0.3-0.3-0.7-0.5-1.1-0.6 c-0.3-0.1-1-0.1-2-0.1C23.1,27.3,21.7,27.3,21.7,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.8,38.9v-14h5.9c1.5,0,2.6,0.1,3.2,0.4c0.7,0.3,1.2,0.7,1.6,1.3c0.4,0.6,0.6,1.4,0.6,2.2 c0,1.1-0.3,1.9-0.9,2.6c-0.6,0.7-1.5,1.1-2.7,1.3c0.6,0.4,1.1,0.8,1.5,1.2s0.9,1.2,1.6,2.3l1.7,2.7H41l-2-3.1 c-0.7-1.1-1.2-1.8-1.5-2.1s-0.5-0.5-0.8-0.6s-0.8-0.2-1.4-0.2h-0.6v5.9L31.8,38.9L31.8,38.9z M34.6,30.8h2.1 c1.3,0,2.2-0.1,2.5-0.2s0.6-0.3,0.8-0.6c0.2-0.3,0.3-0.6,0.3-1.1s-0.1-0.9-0.4-1.1c-0.2-0.3-0.6-0.5-1.1-0.6c-0.2,0-0.9,0-2,0 h-2.2C34.6,27.2,34.6,30.8,34.6,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.2,32c0-1.4,0.2-2.6,0.6-3.6c0.3-0.7,0.7-1.4,1.3-1.9c0.5-0.6,1.1-1,1.8-1.3c0.9-0.4,1.9-0.6,3-0.6 c2,0,3.7,0.6,4.9,1.9s1.8,3.1,1.8,5.4s-0.6,4-1.8,5.3s-2.8,1.9-4.9,1.9c-2.1,0-3.7-0.6-4.9-1.9C45.8,36,45.2,34.2,45.2,32z  M48.1,31.9c0,1.6,0.4,2.8,1.1,3.6c0.7,0.8,1.6,1.2,2.8,1.2c1.1,0,2-0.4,2.7-1.2s1.1-2,1.1-3.7c0-1.6-0.3-2.8-1-3.6 C54.1,27.4,53.2,27,52,27s-2.1,0.4-2.8,1.2C48.4,29.1,48.1,30.3,48.1,31.9z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProIcon);
export default __webpack_public_path__ + "static/media/pro-icon.031d443352925e61293962d61fa39c33.svg";
export { ForwardRef as ReactComponent };